"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const react_1 = require("react");
const tooltip_module_scss_1 = __importDefault(require("../tooltip.module.scss"));
const classnames_1 = __importDefault(require("classnames"));
const pattern_library_components_icon_1 = require("@saatva-bits/pattern-library.components.icon");
const TooltipDialog = ({ isMobile, dialogWidth, isToolTipActive, dialogPinned, dialogClassName, toolTipTextBlocks, toggleToolTip, showMobileDialogCloseIcon, tooltipRef, dialogRef }) => {
    const [positionTop, setPositionTop] = (0, react_1.useState)('auto');
    (0, react_1.useEffect)(() => {
        const tooltip = tooltipRef.current;
        tooltip && setPositionTop(tooltip.offsetHeight + 10);
    }, []);
    const positionStyle = {
        bottom: `${positionTop}px`,
        width: isMobile ? (dialogWidth || '100%') : '350px',
        maxWidth: 'none',
    };
    const toolTipDialogClasses = (0, classnames_1.default)({
        [tooltip_module_scss_1.default['toolTip__dialog']]: true,
        [tooltip_module_scss_1.default['is-visible']]: isToolTipActive,
        [tooltip_module_scss_1.default[`toolTip__dialog--pinned`]]: dialogPinned,
        [tooltip_module_scss_1.default['toolTip__dialog--withCloseIcon']]: showMobileDialogCloseIcon && isMobile
    }, dialogClassName);
    const dialogTextBlockClasses = (0, classnames_1.default)(tooltip_module_scss_1.default['toolTip__dialogContent'], {
        [tooltip_module_scss_1.default['toolTip__dialogContent--withCloseIcon']]: showMobileDialogCloseIcon && isMobile
    });
    return ((0, jsx_runtime_1.jsxs)("aside", { id: "tooltip-dialog", ref: dialogRef, style: positionStyle, className: toolTipDialogClasses, children: [isMobile && showMobileDialogCloseIcon &&
                (0, jsx_runtime_1.jsx)(pattern_library_components_icon_1.Icon, { alt: "Close Icon", className: `${tooltip_module_scss_1.default['toolTip__mobileDialogClose']}`, description: "Close Dialog", fill: "#62c2b1", height: "16", name: "close", width: "16", onClick: (e) => toggleToolTip(e, false, tooltipRef.current) }), toolTipTextBlocks.map((textBlock, index) => ((0, jsx_runtime_1.jsx)("span", { className: dialogTextBlockClasses, children: textBlock }, index)))] }));
};
exports.default = TooltipDialog;
//# sourceMappingURL=TooltipDialog.js.map